import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Parallax } from 'react-spring/renderprops-addons.cjs'

// Components
import Layout from '../components/Layout'
import ProjectCard from '../components/ProjectCard'

// Elements
import Inner from '../elements/Inner'
import { Title, BigTitle, Subtitle } from '../elements/Titles'

// Views
import Hero from '../views/Hero'
import Projects from '../views/Projects'
import About from '../views/About'
import Contact from '../views/Contact'

import avatar from '../images/avatar.jpg'
import Badge from '../components/Badge'

const ProjectsWrapper = styled.div`
  ${tw`flex flex-wrap justify-between mt-8`};
  display: grid;
  grid-gap: 4rem;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 1200px) {
    grid-gap: 3rem;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
`

const AboutHero = styled.div`
  ${tw`flex flex-col lg:flex-row items-center mt-8`};
`

const Avatar = styled.img`
  ${tw`rounded-full w-32 xl:w-48 shadow-lg h-auto`};
`

const AboutSub = styled.span`
  ${tw`text-white pt-12 lg:pt-0 lg:pl-12 text-2xl lg:text-3xl xl:text-4xl`};
`

const AboutDesc = styled.p`
  ${tw`text-grey-light text-lg md:text-xl lg:text-2xl font-sans pt-6 md:pt-12 text-justify`};
`

const ContactText = styled.p`
  ${tw`text-grey-light font-sans text-xl md:text-2xl lg:text-3xl`};
`

const Footer = styled.footer`
  ${tw`text-center text-grey absolute pin-b p-6 font-sans text-md lg:text-lg`};
`

const Index = () => (
  <>
    <Layout />
    <Parallax pages={5}>
      <Hero offset={0}>
        <BigTitle>
          Hello, <br /> I'm Deniz Engin.
        </BigTitle>
        <Subtitle>I am a software engineering leader with a passion for web and mobile technologies.
          Scroll below to learn more about me, or have a look at my <a href='https://denizengin.tumblr.com'>blog.</a>
        </Subtitle>
        </Hero>
      <Projects offset={1}>
        <Title>Work Experience</Title>
        <ProjectsWrapper>
          <ProjectCard
            title="Tesco"
            link="https://www.tesco.com"
            bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)"
          >
            Managing teams delivering next generation online shopping experiences.
          </ProjectCard>
          <ProjectCard
            title="BigHand"
            link="https://www.bighand.com"
            bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)"
          >
            Together with my team, lead the transformation of the company from desktop into web development.
          </ProjectCard>
          <ProjectCard
            title="Worldpay"
            link="https://www.worldpay.com"
            bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)"
          >
            Formed a permanent team of web developers to take over from contractors.
          </ProjectCard>
          <ProjectCard
            title="Microsoft / Skype"
            link="https://www.microsoft.com"
            bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)"
          >
            Worked on building responsive single page applications, and scalable cloud based APIs
          </ProjectCard>
          <ProjectCard
            title="Avanade"
            link="https://www.avanade.com"
            bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)"
          >
            Worked as a consultant at various placements including ITV
          </ProjectCard>
          <ProjectCard
            title="Condeco"
            link="https://www.condecosoftware.com/"
            bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)"
          >
            Created ASP.NET reporting solutions and utilised data warehousing techniques
          </ProjectCard>
          <ProjectCard title="Other Companies" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)">
            Worked at MediaCorp building a sports website, and created a job search website as an entrepreneurial
            project
          </ProjectCard>
        </ProjectsWrapper>
      </Projects>
      <About offset={3}>
        <Title>About</Title>
        <AboutHero>
          <Avatar src={avatar} alt="Deniz Vehbi" />
          <AboutSub>
            I've had a passion for the Web since its early days and started my career as a Web developer.
            I've gradually moved into technical leadership roles but still kept partially hands on.
          </AboutSub>
        </AboutHero>
      </About>
      <Contact offset={3.8}>
        <Inner>
          <Title>Get in touch</Title>
          <Badge />
        </Inner>
        <Footer>&copy; {new Date().getFullYear()}</Footer>
      </Contact>
    </Parallax>
  </>
)

export default Index
